import { readStoredAuth } from '../api/authApi';
import { createCrashReport } from '../api/clients/errorReportsClient';

const CRASH_FINGERPRINT_PREFIX = 'cv.crash.sent:';

function buildCrashFingerprint(payload) {
    const supportCode = String(payload?.support_code || '');
    const digest = String(payload?.error_digest || '');
    const text = String(payload?.report_text || '');
    return `${supportCode}|${digest}|${text}`;
}

function markCrashAsSent(fingerprint) {
    if (typeof window === 'undefined' || !fingerprint) {
        return;
    }

    try {
        window.sessionStorage.setItem(`${CRASH_FINGERPRINT_PREFIX}${fingerprint}`, '1');
    } catch {
        // Ignorar: no bloquear el flujo por storage.
    }
}

function wasCrashAlreadySent(fingerprint) {
    if (typeof window === 'undefined' || !fingerprint) {
        return false;
    }

    try {
        return window.sessionStorage.getItem(`${CRASH_FINGERPRINT_PREFIX}${fingerprint}`) === '1';
    } catch {
        return false;
    }
}

export async function reportCrashToServer(payload) {
    const fingerprint = buildCrashFingerprint(payload);
    if (!fingerprint || wasCrashAlreadySent(fingerprint)) {
        return;
    }

    let token = null;
    try {
        const auth = await readStoredAuth();
        token = auth?.token || null;
    } catch {
        token = null;
    }

    if (!token) {
        return;
    }

    try {
        await createCrashReport(token, payload);
        markCrashAsSent(fingerprint);
    } catch {
        // Best effort: no romper la UI de fallback por falla de red/API.
    }
}
